'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDOMReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-gmaps/dist/events/info-window.js
 ** module id = 174
 ** module chunks = 0
 **/